import { Box } from '@mui/material';
import { Route } from 'app/enums';
import { TournamentEntity } from 'app/interfaces/entity';
import isEmpty from 'lodash/isEmpty';
import { useTournamentDetails } from 'modules/tournaments/hooks';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoaderButton } from 'shared/components/LoaderButton/LoaderButton';
import { useStyles } from 'modules/tournaments/components/BracketTournament/TournamentControls/TournamentControls.styles';

interface TournamentControlsProps {
  tournament: TournamentEntity;
}

export const TournamentControls: FC<TournamentControlsProps> = ({ tournament }) => {
  const navigate = useNavigate();
  const { classes } = useStyles();
  const { isLiveTournament, isCanceledTournament, isFinishedTournament } = useTournamentDetails();

  const currentPlayer = useSelector(currentTournamentSelector.currentPlayer);

  const onJoinHandler = useCallback(
    () => navigate(Route.TournamentMyTeam.replace(':id', tournament?.id ?? '')),
    [navigate, tournament?.id]
  );

  const isCurrentUserInvitedAsSpectator = useSelector(
    currentTournamentSelector.isCurrentUserInvitedAsSpectator
  );

  if (
    !isEmpty(currentPlayer) ||
    isLiveTournament ||
    isCanceledTournament ||
    isFinishedTournament ||
    isCurrentUserInvitedAsSpectator
  ) {
    return null;
  }

  return (
    <Box className={classes.root}>
      <LoaderButton fullWidth variant="contained" color="primary" onClick={onJoinHandler}>
        Join Tournament
      </LoaderButton>
    </Box>
  );
};
